import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import useDocumentTitle from '_/hooks/useDocumentTitle';
import React, { ReactElement } from 'react';

const title = 'Delivery';

function DeliveriesContainer(): ReactElement {
  useDocumentTitle(title);

  return (
    <AsyncPageContainer isLoading={false}>
      <Outlet />
    </AsyncPageContainer>
  );
}

export default DeliveriesContainer;
